import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import NewsService from "./newsService";

export const getNewss = createAsyncThunk("News/get-Newss", async (thunkAPI) => {
  try {
    return await NewsService.getNewss();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
export const createNewss = createAsyncThunk(
  "News/create-Newss",
  async (NewsData, thunkAPI) => {
    try {
      return await NewsService.createNews(NewsData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getANews = createAsyncThunk(
  "News/get-News",
  async (id, thunkAPI) => {
    try {
      return await NewsService.getNews(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateANews = createAsyncThunk(
  "News/update-News",
  async (brand, thunkAPI) => {
    try {
      return await NewsService.updateNews(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteNews = createAsyncThunk(
  "News/delete-News",
  async (id, thunkAPI) => {
    try {
      return await NewsService.deleteNews(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Newss: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const NewsSlice = createSlice({
  name: "Newss",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNewss.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNewss.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Newss = action.payload.data;
      })
      .addCase(getNewss.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createNewss.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNewss.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdNews = action.payload;
      })
      .addCase(createNewss.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getANews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getANews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.NewsAuthor=action.payload.data.author;
        state.NewsName = action.payload.data.title;
        state.NewsDesc = action.payload.data.content;
        state.NewsCategory = action.payload.data.categoryName;
        state.NewsImages = action.payload.images;
      })
      .addCase(getANews.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateANews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateANews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedNews = action.payload;
      })
      .addCase(updateANews.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteNews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedNews = action.payload;
      })
      .addCase(deleteNews.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default NewsSlice.reducer;
